var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-top": "-18px"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('legend', [_vm._v("Pallet Search Report")]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12 radio"
  }, [_c('b-form-fieldset', [_c('b-form-radio', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "selected",
      "id": "searchview",
      "plain": true,
      "options": _vm.options
    },
    on: {
      "change": _vm.selectRadio
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selected')),
      expression: "errors.has('selected')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Select search type field is required.")])], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "margin-top": "0rem",
      "margin-bottom": "0rem"
    }
  })], 1)]), _vm._v(" "), (_vm.selected === 'awb') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbNumbers),
      expression: "awbNumbers"
    }],
    class: {
      'form-control': true, 'error': _vm.hasAwbErrors
    },
    attrs: {
      "name": "awbNumbers",
      "rows": "4",
      "id": "awbNumbers",
      "placeholder": "Enter comma-separated AWB numbers (max 50)",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.awbNumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbNumbers = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasAwbErrors),
      expression: "hasAwbErrors"
    }],
    staticClass: "text-danger"
  }, [(_vm.errorMessages.required) ? [_vm._v("\n                        " + _vm._s(_vm.errorMessages.required) + "\n                      ")] : _vm._e(), _vm._v(" "), (_vm.errorMessages.limitExceeded) ? [_vm._v("\n                        " + _vm._s(_vm.errorMessages.limitExceeded) + "\n                      ")] : _vm._e()], 2)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selected != 'destinationhubid' && _vm.selected != 'clientid' && _vm.selected != 'awb' && _vm.selected != 'occupancy' && _vm.selected != 'sector' && _vm.selected != 'route') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.binpalletawbmps),
      expression: "binpalletawbmps"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "no",
    staticClass: "form-control",
    attrs: {
      "name": "binpalletawbmps",
      "placeholder": "Enter Number",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.binpalletawbmps)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.binpalletawbmps = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('binpalletawbmps')),
      expression: "errors.has('binpalletawbmps')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Enter number field is required.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selected == 'destinationhubid') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('hubname')
    },
    attrs: {
      "options": _vm.hublist,
      "label": "text",
      "track-by": "value",
      "placeholder": "Select destination hub",
      "show-labels": false,
      "multiple": false,
      "clearable": false,
      "name": "hubname"
    },
    on: {
      "select": _vm.setSelectedHub
    },
    model: {
      value: (_vm.hubname),
      callback: function($$v) {
        _vm.hubname = $$v
      },
      expression: "hubname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('hubname')),
      expression: "errors.has('hubname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Destination Hub Name field is required.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selected == 'clientid') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('clientname')
    },
    attrs: {
      "options": _vm.clientlist,
      "label": "text",
      "track-by": "id",
      "placeholder": "Select client",
      "show-labels": false,
      "multiple": false,
      "clearable": false,
      "name": "clientname"
    },
    on: {
      "select": _vm.setSelectedClient
    },
    model: {
      value: (_vm.clientname),
      callback: function($$v) {
        _vm.clientname = $$v
      },
      expression: "clientname"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('clientname')),
      expression: "errors.has('clientname')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Client Name field is required.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selected === 'sector') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('selectedSector')
    },
    attrs: {
      "options": _vm.sectorlist,
      "label": "text",
      "track-by": "value",
      "placeholder": "Select Sector",
      "show-labels": false,
      "multiple": false,
      "clearable": false,
      "name": "selectedSector"
    },
    model: {
      value: (_vm.selectedSector),
      callback: function($$v) {
        _vm.selectedSector = $$v
      },
      expression: "selectedSector"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selectedSector')),
      expression: "errors.has('selectedSector')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Sector field is required.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selected === 'route') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('selectedRoute')
    },
    attrs: {
      "options": _vm.routelist,
      "label": "text",
      "track-by": "value",
      "placeholder": "Select Route",
      "show-labels": false,
      "multiple": false,
      "clearable": false,
      "name": "selectedRoute"
    },
    model: {
      value: (_vm.selectedRoute),
      callback: function($$v) {
        _vm.selectedRoute = $$v
      },
      expression: "selectedRoute"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selectedRoute')),
      expression: "errors.has('selectedRoute')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Route field is required.")])], 1)], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.selected == 'occupancy') ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-archive'></i>"
    }
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'error': _vm.errors.has('selectedOccupancy')
    },
    attrs: {
      "options": _vm.formattedOccupancyOptions,
      "label": "text",
      "track-by": "value",
      "placeholder": "Select Occupancy",
      "show-labels": false,
      "multiple": false,
      "clearable": false,
      "name": "selectedOccupancy"
    },
    model: {
      value: (_vm.selectedOccupancy),
      callback: function($$v) {
        _vm.selectedOccupancy = $$v
      },
      expression: "selectedOccupancy"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('selectedOccupancy')),
      expression: "errors.has('selectedOccupancy')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Occupancy field is required.")])], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('b-input-group', [_c('button', {
    staticClass: "common-success",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")]), _vm._v(" "), _c('button', {
    staticClass: "btn-warning",
    staticStyle: {
      "border-radius": "5px",
      "color": "#000000ad"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportAllBin
    }
  }, [_vm._v("Download All")])])], 1)], 1)])])], 1)], 1)]), _vm._v(" "), _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.tableLoading
    },
    on: {
      "update:active": function($event) {
        _vm.tableLoading = $event
      }
    }
  }), _vm._v(" "), _c('legend', {
    staticStyle: {
      "background-color": "#fff"
    }
  }, [_vm._v("\n          Pallet Details\n          "), _c('span', [(_vm.palletReportDetails.length > 0) ? _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "70%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.downloadSearchReportcsv
    }
  }, [_vm._v("Download")]) : _vm._e(), _vm._v(" "), (_vm.palletReportDetails.length > 0) ? _c('button', {
    staticClass: "btn-primary",
    staticStyle: {
      "margin-left": "1%"
    },
    on: {
      "click": function($event) {
        return _vm.getPalletizationDataPrint()
      }
    }
  }, [_vm._v("Print")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bin Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Pallet")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("AWB No")]), _vm._v(" "), (_vm.selected == 'mps' || _vm.selected == 'paperno') ? _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS/ PW ID")]) : _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("MPS/ PW Count")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Client ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipping Pin Code")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Sector/Route")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Occupancy")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Palletized By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Date of Palletization")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("No of Palletized Days")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.palletReportDetails), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.binnumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bintype === 0 ? "Rack" : data.bintype === 1 ? "Floor" : data.bintype == "Pigeon Hole" ? "Pigeon Hole" : ""))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.containernumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.parentawb))]), _vm._v(" "), (_vm.selected == 'mps' || _vm.selected == 'paperno') ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shipmentbagnumber))]) : _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mpscount))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.clientid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.shippingpincode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubid == _vm.currentHubId ? data.route : data.sector))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.weight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.occupancy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.lastmodifiedby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(data.lastmodifieddate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.noofpalledtdays))])])
  }), _vm._v(" "), (_vm.palletReportDetails.length <= 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "14",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > 0),
      expression: "totalRows > 0"
    }],
    ref: "paginate",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 10,
      "margin-pages": 10,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f53d1dce","hasScoped":true}!./src/views/components/Palletization/Reports/Reports.html
// module id = 1803
// module chunks = 2